import { useCallback, useMemo, useState } from "react";

import { fetchWithRetry } from "../utils/services.utils";

const SERVER_STATUS = {
  ONLINE: "online",
  MAINTENANCE: "maintenance",
};

const useGetSettings = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const url = useMemo(() => {
    return `https://${process.env.REACT_APP_API}/info/`;
  }, []);

  const getSettings = useCallback(
    (params, options = null) => {
      setData(null);
      setError(null);
      setLoading(true);

      const fetchOptions = {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        signal: options?.signal,
      };

      fetchWithRetry(url, fetchOptions)
        .then((response) => {
          setError(response.error || null);
          delete response.error;
          setData(response);
          setLoading(false);
        })
        .catch((error) => {
          setData(null);
          setError(error);
          setLoading(false);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [url]
  );

  const clear = useCallback(() => {
    setData(null);
    setError(null);
    setLoading(false);
  }, []);

  return { loading, data, error, getSettings, clear };
};

export default useGetSettings;
export { SERVER_STATUS };
